var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf-display"},[_c('div',{staticClass:"page"},_vm._l((_vm.displayData),function(link,index){return _c('img',{staticClass:"image",attrs:{"src":link}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }